var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    [
      _c(
        "v-card",
        {
          staticClass: "justify-center",
          attrs: { flat: "", id: "datastory-" + _vm.datastory.id }
        },
        [
          _c(
            "v-layout",
            {
              attrs: {
                row: "",
                wrap: "",
                "align-center": "",
                reverse: _vm.reversing && !_vm.expandStory
              }
            },
            [
              _c(
                "v-flex",
                {
                  attrs: {
                    xs12: _vm.expandStory,
                    sm12: !_vm.expandStory,
                    md6: !_vm.expandStory,
                    md10: _vm.expandStory,
                    lg8: _vm.expandStory,
                    "offset-md1": _vm.expandStory,
                    "offset-lg2": _vm.expandStory,
                    "justify-end": !_vm.expandStory,
                    "order-xs2": ""
                  }
                },
                [
                  _c("v-card-title", { staticClass: "pb-0" }, [
                    !_vm.expandStory
                      ? _c("h3", { staticClass: "flex xs12 display-1" }, [
                          _vm._v(_vm._s(_vm.datastory.story.title))
                        ])
                      : _vm._e(),
                    _vm._v(" "),
                    _c(
                      "h3",
                      { staticClass: "flex xs12 font-weight-thin font-italic" },
                      [
                        _vm._v(
                          _vm._s(
                            _vm.formatPublicationDate(
                              _vm.datastory.publication_date
                            )
                          )
                        )
                      ]
                    ),
                    _vm._v(" "),
                    _vm.expandStory
                      ? _c("h2", { staticClass: "flex xs12 display-2" }, [
                          _vm._v(_vm._s(_vm.datastory.story.title))
                        ])
                      : _vm._e()
                  ]),
                  _vm._v(" "),
                  _c("v-card-text", {
                    staticClass: "headline",
                    domProps: { innerHTML: _vm._s(_vm.datastory.story.teaser) }
                  }),
                  _vm._v(" "),
                  _c(
                    "v-flex",
                    { attrs: { "offset-xs10": !_vm.reversing } },
                    [
                      !_vm.archived
                        ? _c(
                            "v-btn",
                            {
                              attrs: {
                                small: "",
                                flat: "",
                                round: "",
                                color: "primary"
                              },
                              on: {
                                click: function($event) {
                                  return _vm.toggleDataStory()
                                }
                              }
                            },
                            [_vm._v(_vm._s(_vm.btnLabel))]
                          )
                        : _vm._e()
                    ],
                    1
                  )
                ],
                1
              ),
              _vm._v(" "),
              _c(
                "v-flex",
                {
                  attrs: {
                    xs12: _vm.expandStory,
                    sm12: !_vm.expandStory,
                    md6: !_vm.expandStory,
                    "order-xs1": ""
                  }
                },
                [
                  _c("v-img", {
                    attrs: {
                      height: "35rem",
                      src: require("@/assets/img/datastories/" +
                        _vm.getTeaserImage(_vm.datastory.images))
                    }
                  })
                ],
                1
              ),
              _vm._v(" "),
              _c(
                "v-flex",
                { attrs: { md12: "", "order-xs3": "" } },
                [
                  _c(
                    "v-slide-y-transition",
                    [
                      _c(
                        "v-card-text",
                        {
                          directives: [
                            {
                              name: "show",
                              rawName: "v-show",
                              value: _vm.expandStory,
                              expression: "expandStory"
                            }
                          ]
                        },
                        [
                          _c(
                            "v-layout",
                            { attrs: { row: "", wrap: "" } },
                            [
                              _c(
                                "v-flex",
                                {
                                  staticClass:
                                    "xs12 md10 lg8 offset-md1 offset-lg2 mt-2"
                                },
                                [
                                  _c(
                                    "v-card",
                                    { attrs: { flat: "" } },
                                    [
                                      _c("v-card-text", {
                                        domProps: {
                                          innerHTML: _vm._s(
                                            _vm.datastory.story.content
                                          )
                                        }
                                      }),
                                      _vm._v(" "),
                                      _c(
                                        "v-card-text",
                                        [
                                          _c(
                                            "v-carousel",
                                            {
                                              attrs: {
                                                light: "",
                                                "pa-3": "",
                                                "hide-delimiters": false,
                                                interval: "15000",
                                                cycle: false
                                              }
                                            },
                                            _vm._l(
                                              _vm.sortImages(
                                                _vm.datastory.images
                                              ),
                                              function(img, index) {
                                                return _c(
                                                  "v-carousel-item",
                                                  { key: index },
                                                  [
                                                    _c(
                                                      "v-img",
                                                      {
                                                        attrs: {
                                                          height: "35rem",
                                                          src: require("@/assets/img/datastories/" +
                                                            img.file),
                                                          alt: img.alt,
                                                          contain: ""
                                                        }
                                                      },
                                                      [
                                                        _c(
                                                          "v-container",
                                                          {
                                                            attrs: {
                                                              "fill-height": "",
                                                              fluid: ""
                                                            }
                                                          },
                                                          [
                                                            _c(
                                                              "v-layout",
                                                              {
                                                                staticClass:
                                                                  "lighten-4 carousel-captions",
                                                                attrs: {
                                                                  "fill-height":
                                                                    ""
                                                                }
                                                              },
                                                              [
                                                                _c(
                                                                  "v-flex",
                                                                  {
                                                                    attrs: {
                                                                      "pt-2": ""
                                                                    }
                                                                  },
                                                                  [
                                                                    _c(
                                                                      "span",
                                                                      {
                                                                        staticClass:
                                                                          "pa-2 white title blue--text text--darken-2"
                                                                      },
                                                                      [
                                                                        _vm._v(
                                                                          _vm._s(
                                                                            img.caption
                                                                          )
                                                                        )
                                                                      ]
                                                                    )
                                                                  ]
                                                                )
                                                              ],
                                                              1
                                                            )
                                                          ],
                                                          1
                                                        )
                                                      ],
                                                      1
                                                    )
                                                  ],
                                                  1
                                                )
                                              }
                                            ),
                                            1
                                          )
                                        ],
                                        1
                                      )
                                    ],
                                    1
                                  )
                                ],
                                1
                              ),
                              _vm._v(" "),
                              _c(
                                "v-flex",
                                {
                                  attrs: {
                                    xs12: "",
                                    md10: "",
                                    lg8: "",
                                    "offset-md1": "",
                                    "offset-lg2": "",
                                    mt2: ""
                                  }
                                },
                                [
                                  _c(
                                    "v-expansion-panel",
                                    [
                                      _c(
                                        "v-expansion-panel-content",
                                        [
                                          _c(
                                            "h4",
                                            {
                                              staticClass: "display-1",
                                              attrs: { slot: "header" },
                                              slot: "header"
                                            },
                                            [_vm._v("Methodology")]
                                          ),
                                          _vm._v(" "),
                                          _c(
                                            "v-card",
                                            { attrs: { flat: "" } },
                                            [
                                              _c("v-card-text", [
                                                _c(
                                                  "p",
                                                  { staticClass: "subheading" },
                                                  [
                                                    _vm._v(
                                                      "For full methodological information, please "
                                                    ),
                                                    _c(
                                                      "a",
                                                      {
                                                        attrs: {
                                                          href:
                                                            "static/handbook.pdf"
                                                        }
                                                      },
                                                      [
                                                        _vm._v(
                                                          "download the KNOWMAK user handbook"
                                                        )
                                                      ]
                                                    ),
                                                    _vm._v(".")
                                                  ]
                                                ),
                                                _vm._v(" "),
                                                _c("div", {
                                                  domProps: {
                                                    innerHTML: _vm._s(
                                                      _vm.datastory.story
                                                        .methodology
                                                    )
                                                  }
                                                })
                                              ])
                                            ],
                                            1
                                          )
                                        ],
                                        1
                                      ),
                                      _vm._v(" "),
                                      _vm.datastory.hasOwnProperty("resources")
                                        ? _c(
                                            "v-expansion-panel-content",
                                            [
                                              _c(
                                                "h4",
                                                {
                                                  staticClass: "display-1",
                                                  attrs: { slot: "header" },
                                                  slot: "header"
                                                },
                                                [_vm._v("Additional Resources")]
                                              ),
                                              _vm._v(" "),
                                              _c(
                                                "v-card",
                                                { attrs: { flat: "" } },
                                                [
                                                  _c("v-card-text", [
                                                    _c(
                                                      "ul",
                                                      _vm._l(
                                                        _vm.datastory.resources,
                                                        function(resource) {
                                                          return _c(
                                                            "li",
                                                            {
                                                              key:
                                                                "resource_datastory_" +
                                                                _vm.datastory
                                                                  .id +
                                                                "_" +
                                                                resource.id
                                                            },
                                                            [
                                                              _c(
                                                                "a",
                                                                {
                                                                  attrs: {
                                                                    href:
                                                                      "/static/resources/" +
                                                                      resource.file,
                                                                    target:
                                                                      "_blank"
                                                                  }
                                                                },
                                                                [
                                                                  _vm._v(
                                                                    "Download " +
                                                                      _vm._s(
                                                                        resource.name
                                                                      )
                                                                  )
                                                                ]
                                                              )
                                                            ]
                                                          )
                                                        }
                                                      ),
                                                      0
                                                    )
                                                  ])
                                                ],
                                                1
                                              )
                                            ],
                                            1
                                          )
                                        : _vm._e()
                                    ],
                                    1
                                  )
                                ],
                                1
                              )
                            ],
                            1
                          )
                        ],
                        1
                      )
                    ],
                    1
                  )
                ],
                1
              )
            ],
            1
          )
        ],
        1
      )
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-62d8c42a", esExports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-62d8c42a","hasScoped":true,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/DataStory.vue
// module id = null
// module chunks = 